import React, { FC, memo, useEffect } from "react";
import { createUseStyles } from "react-jss";

import Point from "Assets/images/point.svg";
import LocationBlue from "Assets/images/location_blue.svg";
import SwitchStartDestination from "Assets/images/switch_start_destination.svg";
import WayPoints from "Components/Waypoints";
import Autocomplete from "Containers/AutoComplete";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  showDirections;
  suggestions: any[];
  startingPoint: any;
  destination: any;
  setStartingPoint: (val: any) => void;
  setDestination: (val: any) => void;
  swap: () => void;
  setShowDirections: (setShowDirections: boolean) => void;
  instructions: string[];
  directionsRef: any;
}

const StartDestination: FC<Props> = memo((props: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });
  const {
    showDirections,
    suggestions,
    startingPoint,
    destination,
    setStartingPoint,
    setDestination,
    setShowDirections,
    swap,
    instructions,
    directionsRef,
  } = props;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const closeButton = document.getElementById("close-button");
      if (
        event.key === "Tab" &&
        document.activeElement.id === "switch-button" &&
        closeButton &&
        instructions.length === 0
      ) {
        event.preventDefault();
        closeButton.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line
  }, [suggestions]);

  return (
    <div
      id="startDestination"
      className={`${classes.mainContainer} ${
        showDirections ? "" : classes.startLeft
      }`}
    >
      <div style={{ marginRight: "20px" }} className={classes.iconsContainer}>
        <Point />
        <div className={classes.stop} />
        <div className={classes.stop} />
        <div className={classes.stop} />
        <LocationBlue />
      </div>
      <div className={classes.inputContainer}>
        <Autocomplete
          isStartingPoint
          setShowDirections={setShowDirections}
          placeholder="Choose starting point"
          selectedInputValue={startingPoint.title || ""}
          setUserSelection={setStartingPoint}
          suggestions={suggestions}
          directionsRef={directionsRef}
        />
        <Autocomplete
          isStartingPoint={false}
          setShowDirections={setShowDirections}
          placeholder="Choose destination"
          selectedInputValue={destination.title || ""}
          setUserSelection={setDestination}
          suggestions={suggestions}
          directionsRef={null}
        />
      </div>
      <button
        id="switch-button"
        aria-label="Switch start and destination"
        className={showDirections ? classes.switchButton : classes.switchDest}
        onClick={swap}
      >
        <SwitchStartDestination className={classes.switch} />
      </button>
      {instructions.length > 0 && (
        <WayPoints steps={instructions} showTitle={false} />
      )}
    </div>
  );
}, areEqualShallow);

export default StartDestination;
try {
    // @ts-ignore
    StartDestination.displayName = "StartDestination";
    // @ts-ignore
    StartDestination.__docgenInfo = { "description": "", "displayName": "StartDestination", "props": { "showDirections": { "defaultValue": null, "description": "", "name": "showDirections", "required": true, "type": { "name": "any" } }, "suggestions": { "defaultValue": null, "description": "", "name": "suggestions", "required": true, "type": { "name": "any[]" } }, "startingPoint": { "defaultValue": null, "description": "", "name": "startingPoint", "required": true, "type": { "name": "any" } }, "destination": { "defaultValue": null, "description": "", "name": "destination", "required": true, "type": { "name": "any" } }, "setStartingPoint": { "defaultValue": null, "description": "", "name": "setStartingPoint", "required": true, "type": { "name": "(val: any) => void" } }, "setDestination": { "defaultValue": null, "description": "", "name": "setDestination", "required": true, "type": { "name": "(val: any) => void" } }, "swap": { "defaultValue": null, "description": "", "name": "swap", "required": true, "type": { "name": "() => void" } }, "setShowDirections": { "defaultValue": null, "description": "", "name": "setShowDirections", "required": true, "type": { "name": "(setShowDirections: boolean) => void" } }, "instructions": { "defaultValue": null, "description": "", "name": "instructions", "required": true, "type": { "name": "string[]" } }, "directionsRef": { "defaultValue": null, "description": "", "name": "directionsRef", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/StartDestination/StartDestination.tsx#StartDestination"] = { docgenInfo: StartDestination.__docgenInfo, name: "StartDestination", path: "src/shared/components/StartDestination/StartDestination.tsx#StartDestination" };
}
catch (__react_docgen_typescript_loader_error) { }